import { init } from '@instantdb/react';
import { schema } from './schema';

const APP_ID = process.env.EXPO_PUBLIC_INSTANT_APP_ID;

if (!APP_ID) {
  throw new Error(
    'EXPO_PUBLIC_INSTANT_APP_ID is not set. Add it to your .env file.',
  );
}

export const db = init({
  appId: APP_ID,
  schema,
});
